import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LanguageToggle from './LanguageToggle';

const Header = ({ t, lang, onLanguageToggle }) => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header className={`header-nav ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        <div className="logo-container">
          <img src="/logo.svg" alt="Krypton9" className="logo-icon" />
          <h1 className="logo-text">KRYPTON9</h1>
        </div>
        
        <nav className="nav-menu">
          <button onClick={() => scrollToSection('services')} className="nav-link">
            {t.nav.services}
          </button>
          <button onClick={() => scrollToSection('about')} className="nav-link">
            {t.nav.about}
          </button>
          <button onClick={() => scrollToSection('resources')} className="nav-link">
            {t.nav.resources}
          </button>
          <button onClick={() => scrollToSection('contact')} className="nav-link">
            {t.nav.contact}
          </button>
        </nav>

        <div className="nav-actions">
          <LanguageToggle currentLang={lang} onToggle={onLanguageToggle} />
          <button 
            onClick={() => navigate('/login')} 
            className="btn-secondary"
          >
            {lang === 'en' ? 'Sign In' : 'Inloggen'}
          </button>
          <button 
            onClick={() => scrollToSection('contact')} 
            className="btn-primary"
          >
            {t.nav.schedule}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
